import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { retrievePageMenu } from "../../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../../redux/store";

const PageTitleComponent = () => {
  const { RapsEuropeData: pageMenuData } = useSelector((state: RootState) => state.rapsEurope);
  const [pageTitle, setPageTitle] = useState("");

  useEffect(() => {
    dispatch(retrievePageMenu("%2FPreferences"));
  }, []);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (pageMenuData && pageMenuData[0]) {
      if (pageMenuData[0].result[0]?.menuItemName) setPageTitle(pageMenuData[0].result[0]?.menuItemName?.replace(" | RAPS", ""));
    }
  }, [pageMenuData]);
  return (
    <>
      <h1>{pageTitle}</h1>
    </>
  );
};

export default PageTitleComponent;
